import { createTypes } from '../../utils/helpers';

const ATTRIBUTES_FETCH: any = createTypes('ATTRIBUTES_FETCH');
const ATTRIBUTES_MODEL_FETCH: any = createTypes('ATTRIBUTES_MODEL_FETCH');
const ATTRIBUTES_ARCHIVE: any = createTypes('ATTRIBUTES_ARCHIVE');
const ATTRIBUTES_CATEGORIES_FETCH: any = createTypes(
  'ATTRIBUTES_CATEGORIES_FETCH',
);
const LANGUAGES_FETCH: any = createTypes('LANGUAGES_FETCH');
const RESTAURANT_ATTRIBUTE_UPDATE: any = createTypes(
  'RESTAURANT_ATTRIBUTE_UPDATE',
);
const ATTRIBUTES_MASS_UPDATE: any = createTypes('ATTRIBUTES_MASS_UPDATE');

export {
  ATTRIBUTES_FETCH,
  ATTRIBUTES_ARCHIVE,
  ATTRIBUTES_CATEGORIES_FETCH,
  ATTRIBUTES_MODEL_FETCH,
  LANGUAGES_FETCH,
  RESTAURANT_ATTRIBUTE_UPDATE,
  ATTRIBUTES_MASS_UPDATE,
};
